import React from 'react';
import styled, { keyframes } from 'styled-components';
import { bounceIn } from 'react-animations';
import config from '../config';
import theme from '../theme';

const bounceAnimation = keyframes`${bounceIn}`;

const SSplat = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: 1s ${bounceAnimation};
`;

const SSplatText = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 0;
  height: inherit;
  color: ${theme.textSecondary};
`;

interface IResultSplat {
  splatScore: number;
}

interface IResultSplatState {
  width: number;
  height: number;
}

export default class ResultSplat extends React.PureComponent<
  IResultSplat,
  IResultSplatState
> {
  constructor(props: IResultSplat) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  randomOneToHundred(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  generateBorderRadius() {
    const a = this.randomOneToHundred(40, 70);
    const b = this.randomOneToHundred(30, 80);
    const c = this.randomOneToHundred(40, 70);
    const d = this.randomOneToHundred(30, 80);
    return `${a}% ${b}% ${c}% ${d}%`;
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { splatScore } = this.props;

    const splatWidth = this.state.width < 430 ? 4 : this.state.width < 1050 ? 6 : 8;
    const orientation = this.state.width > this.state.height ? 'vh' : 'vw'
    const canvasLeft = 30;
    const canvasTop = 15;
    const canvasWidth = 90;
    const canvasHeight = 90;

    const randomWidth = this.randomOneToHundred(
      canvasLeft,
      canvasWidth
    );

    const randomHeight = this.randomOneToHundred(
      canvasTop,
      canvasHeight
    );

    return (
      <SSplat
        style={{
          top: `${randomHeight}vh`,
          left: `${randomWidth}vw`,
          height: `${splatWidth}${orientation}`,
          width: `${splatWidth}${orientation}`,
          borderRadius: `${this.generateBorderRadius()}`,
          background: `${config.formScale[splatScore].color}`,
        }}
      >
        <SSplatText>{splatScore}</SSplatText>
      </SSplat>
    );
  }
}
